import { render, staticRenderFns } from "./ImageField.vue?vue&type=template&id=16cf0d10&scoped=true"
import script from "./ImageField.vue?vue&type=script&lang=js"
export * from "./ImageField.vue?vue&type=script&lang=js"
import style0 from "./ImageField.vue?vue&type=style&index=0&id=16cf0d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf0d10",
  null
  
)

export default component.exports